import { render, staticRenderFns } from "./TodayAlarm.vue?vue&type=template&id=477f6657&scoped=true"
import script from "./TodayAlarm.vue?vue&type=script&lang=js"
export * from "./TodayAlarm.vue?vue&type=script&lang=js"
import style0 from "./TodayAlarm.vue?vue&type=style&index=0&id=477f6657&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477f6657",
  null
  
)

export default component.exports